<template>
    <div :class="$style['bank']">
        <div :class="[$style['bank__row'], program.isDisabled ? $style['program-disabled'] : '']">
            <div :class="$style['bank__top']">
                <div v-if="program.logo" :class="$style['bank__icon']">
                    <a :href="program.link" target="_blank">
                        <img :src="program.logo" alt=""></a>
                </div>
                <div :class="$style['bank__name']" :style="{color: `#${program.color}`}">
                    {{ program.bank }}
                    <Tooltip v-if="program.tooltip && program.tooltip.text"
                             :class="$style['bank__name-circle']">
                        {{ program.tooltip.text }}
                    </Tooltip>
                </div>
            </div>

            <div :class="$style['bank__caption']">{{ program.name }}</div>

            <div :class="$style['bank__bottom']">
                <div :class="$style['bank__props']">
                    <div :class="$style['bank__prop']">
                        <div :class="$style['bank__prop-ttl']">ставка<span v-if="program.rateNote">*</span></div>
                        <div :class="$style['bank__prop-val']">от {{ program.rate }}%</div>
                    </div>

                    <div :class="$style['bank__prop']">
                        <div :class="$style['bank__prop-ttl']">1-й взнос</div>
                        <div :class="$style['bank__prop-val']">от {{ program.firstPay }}%</div>
                    </div>

                    <div :class="$style['bank__prop']">
                        <div :class="$style['bank__prop-ttl']">срок</div>
                        <div :class="$style['bank__prop-val']">до {{ program.term }} {{ pluralWord(program.term, yearsContext) }}</div>
                    </div>

                    <div :class="[$style['bank__prop'], $style['bank__prop_is_main']]">
                        <div :class="$style['bank__prop-ttl']">платёж</div>
                        <div :class="$style['bank__prop-val']">{{ formatPrice(program.pay) }}</div>
                    </div>
                </div>

                <div :class="$style['bank__submit']">
                    <a @click.prevent="openPopup(program, program)">Подать заявку</a>
                </div>
            </div>

            <div v-if="program.rateNote" :class="[$style['bank__caption'], $style['bank__note']]">* - {{ program.rateNote }}</div>
        </div>

        <div :class="$style['bank__another']" v-if="program.another">

            <div :class="$style['bank__row']">
                <div :class="[$style['bank__another-content'], {[$style['is-open']]: isOpenAnother}]"
                     :style="{maxHeight: maxHeight}"
                     ref="another">
                    <div v-for="another in program.another"
                         :key="another.id"
                         :class="[$style['bank-another-item'], another.isDisabled ? $style['program-disabled'] : '']">

                        <div :class="$style['bank__caption']">{{ another.name }}</div>

                        <div :class="$style['bank__bottom']">
                            <div :class="$style['bank__props']">
                                <div :class="$style['bank__prop']">
                                    <div :class="$style['bank__prop-ttl']">ставка<span v-if="another.rateNote">*</span></div>
                                    <div :class="$style['bank__prop-val']">от {{ another.rate }}%</div>
                                </div>

                                <div :class="$style['bank__prop']">
                                    <div :class="$style['bank__prop-ttl']">1-й взнос</div>
                                    <div :class="$style['bank__prop-val']">от {{ another.firstPay }}%</div>
                                </div>

                                <div :class="$style['bank__prop']">
                                    <div :class="$style['bank__prop-ttl']">срок</div>
                                    <div :class="$style['bank__prop-val']">до {{ another.term }} {{ pluralWord(another.term, yearsContext) }}</div>
                                </div>

                                <div :class="[$style['bank__prop'], $style['bank__prop_is_main']]">
                                    <div :class="$style['bank__prop-ttl']">платёж</div>
                                    <div :class="$style['bank__prop-val']">{{ formatPrice(another.pay) }}</div>
                                </div>
                            </div>

                            <div :class="$style['bank__submit']">
                                <a @click.prevent="openPopup(program, another)">Подать заявку</a>
                            </div>
                        </div>

                        <div v-if="another.rateNote" :class="[$style['bank__caption'], $style['bank__note']]">* - {{ another.rateNote }}</div>

                    </div>
                </div>
            </div>

        </div>

        <Popup ref="popup"
               :isSuccess="isFormSuccess"
               :isError="isFormError"
               @popupClose="setFormInit">
            <Order :bank="bankPopup"
                   :program="programPopup"
                   :personLink="personLink"
                   :sendData="sendData"
                   :isSuccess="isFormSuccess"
                   :isError="isFormError"
                   @formSuccess="setFormSendSuccess"
                   @formError="setFormSendError" />
        </Popup>
    </div>
</template>

<script>
    import Button from '../Button/Button';
    import Tooltip from '../Tooltip/Tooltip'
    import Popup from '../Popup/Popup';
    import Order from '../Order/Order';

    export default {
        components: {
            Button,
            Tooltip,
            Popup,
            Order
        },

        props: ['filter', 'program', 'personLink', 'sendData'],

        data() {
            return {
                isOpenAnother: true,
                maxHeight: '0px',
                yearsContext: ['года', 'лет', 'лет'],
                bankPopup: null,
                programPopup: null,
                isFormSuccess: false,
                isFormError: false
            }
        },

        methods: {
            toggleAnother() {
                this.isOpenAnother = !this.isOpenAnother;

                if (this.isOpenAnother) {
                    this.showAnother();
                } else {
                    this.hideAnother();
                }

                // для sticky
                const interval = setInterval(() => {
                    this.$emit('changeAnother');
                }, 10);

                setTimeout(() => {
                    clearInterval(interval);
                }, 300);
            },

            showAnother() {
                if (this.$refs.another) {
                    this.maxHeight = `${this.$refs.another.scrollHeight}px`;
                }
            },

            hideAnother() {
                this.maxHeight = '0px';
            },

            pluralWord(n, context) {
                const $i = ((n % 10 === 1 && n % 100 !== 11) ? 0 : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2));
                return context[$i];
            },

            setHeightOnResize() {
                if (this.isOpenAnother) {
                    this.showAnother();
                }
            },

            openPopup(bank, program) {
                this.bankPopup = bank;
                this.programPopup = program;
                this.$refs.popup.open();
                this.setDataLayerOpen();
            },

            formatPrice(value) {
                if (value === 0) return '—';

                let val = (value/1).toFixed(0).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' руб.';
            },

            setFormSendSuccess() {
                this.isFormSuccess = true;
                this.isFormError = false;
                this.setDataLayerSend();
            },

            setFormSendError() {
                this.isFormSuccess = false;
                this.isFormError = true;
            },

            setFormInit() {
                this.isFormSuccess = false;
                this.isFormError = false;
            },

            setDataLayerOpen() {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event     : 'GAevent',
                    GAcategory: 'form',
                    GAaction  : 'open',
                    GAlabel   : `mortgageapply-${this.programPopup.id}`
                });

                if (this.$dataset && this.$dataset.flatId) {
                    const price = this.filter && this.filter.sliders && this.filter.sliders.price && this.filter.sliders.price.value || 0;

                    window.dataLayer.push({
                        event: 'AddToCart',
                        products: [{
                            id   : this.$dataset.flatId,
                            price: price.toString()
                        }]
                    });
                }
            },

            setDataLayerSend() {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event     : 'GAevent',
                    GAcategory: 'form',
                    GAaction  : 'send',
                    GAlabel   : `mortgageapply-${this.programPopup.id}`
                });

                if (this.$dataset && this.$dataset.flatId) {
                    const price = this.filter && this.filter.sliders && this.filter.sliders.price && this.filter.sliders.price.value || 0;

                    window.dataLayer.push({
                        event: 'Purchase',
                        products: [{
                            id: this.$dataset.flatId,
                            price: price.toString()
                        }]
                    });
                }
            }
        },

        mounted() {
            this.showAnother();
            window.addEventListener('resize', this.setHeightOnResize);
        },

        destroyed() {
            window.removeEventListener('resize', this.setHeightOnResize);
        }
    }
</script>

<style lang="scss" module>
    @import "Program";
</style>
